import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  if (lenis) return lenis;
  lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  const target = sessionStorage.getItem("scrollTo");
  if (target) {
    sessionStorage.removeItem("scrollTo");
    setTimeout(() => {
      const el = document.getElementById(target);
      if (el) lenis.scrollTo(el, { offset: 0, duration: 1.4 });
    }, 500);
  }
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  return lenis;
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) {
    lenis.scrollTo(el, { offset: 0, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}

export function goToSection(id) {
  const el = document.getElementById(id);
  if (el) {
    scrollToId(id);
    return;
  }
  sessionStorage.setItem("scrollTo", id);
  window.location.href = "/";
}
